import React, {memo, useState} from 'react';
import t from '../../../core/staticData/translation';
import useTranslation from '../../../core/customHooks/useTranslation';
import { getUserWinningInfo } from '../../../state-management/accessors/usersAccessors';
import { connect } from 'react-redux';
import {APP_CONSTANTS, PARTNERS_WITH_CALENDAR_FEATURE} from "../../../core/constants/constants";
import PartnerModule from "../../../core/moduls/PartnerModul";
import Loader from "../loader";

const CalendarPopup = ({ setModalState }) => {
  const [isLoading, setIsLoading] = useState(true);
  const translate = useTranslation();
  const partnerId = PartnerModule.getConfigItem(APP_CONSTANTS.PARTNER_ID);

  const handleClosePopup = () => {
    setModalState('');
  };

  return (
    <div className="wr-user-popup-layout" style={{maxHeight: 630}}>
      <div className="user-popup-layout">
        <div className="top-of-user-popup-layout">
          <div className="popup-profile-header">
            <p className="popup-profile-name" title={translate(t.SYNC_CALENDAR)}>{translate(t.SYNC_CALENDAR)}</p>
            <div className="popup-profile-header-icon"
                 onClick={handleClosePopup}
            >
              <span className="bc-i-close"/>
            </div>
          </div>
        </div>
        <div className="bottom-of-user-popup-layout">
          <div className="scroll-wr">
            <div className="popup-profile-content" style={{height: "100%"}}>
              {isLoading && <Loader />}
              <iframe
                src={PARTNERS_WITH_CALENDAR_FEATURE[partnerId]}
                frameBorder="0"
                onLoad={() => setIsLoading(false)}
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  display: isLoading ? 'none' : 'block', // Prevents unstyled content flashes
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  userWinningInfo: getUserWinningInfo(state)
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(CalendarPopup));

